import { UIMessage } from "ai";

type ChatDataTypes = {
  "conversation-version": { version: number };
  "conversation-description": { description: string };
  "budget-usage": {
    tokensResetAt: number;
    totalTokens: number;
    usedTokens: number;
    usedTokensCurrentTurn: number;
  };
};

export type ChatUIMessage = UIMessage<unknown, ChatDataTypes>;

export enum ChatMode {
  ASK = "ask",
  BUILD = "build",
}

export enum ChatApprovalMode {
  AUTO = "auto",
  MANUAL = "manual",
}

export type ChatToolPayload = {
  title: string | undefined;
  name: string;
  description: string;
  needsApproval?: boolean;
  schema: Record<string, unknown>;
};
